/**
 * @generated SignedSource<<29b05f07a4892143a84ddf87322403fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetArticleLogoArticle$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
      readonly image?: {
        readonly style: {
          readonly url: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly name?: string;
      readonly urlAlias?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersGetArticleLogoArticle";
};
export type helpersGetArticleLogoArticle$key = {
  readonly " $data"?: helpersGetArticleLogoArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetArticleLogoArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetArticleLogoArticle"
};

(node as any).hash = "34f17eb89d31a2dc2352a962b3d1efb7";

export default node;
